import { Box, Link, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const ComingSoonCard = ({ adminUrl }) => {
  return (
    <InnerCard>
      <Text
        variant="body1"
        style={{
          color: colorTokens.text.secondary,
          fontWeight: 300,
        }}
      >
        Under development. Coming Soon.
      </Text>
      <Link target="_blank" underline="none" href={adminUrl} style={{ color: colorTokens.primary.main }}>
        View in Admin
      </Link>
    </InnerCard>
  );
};

const InnerCard = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  width: 100%;

  border-radius: 12px;
  border: 1.38px solid ${colorTokens.border.main};
  background: #f7fafc;
`;
